import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CardComponent } from '../card/card.component';

@Component({
    selector: 'nw-highlight-card',
    templateUrl: './highlight-card.component.html',
    styleUrls: ['./highlight-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CardComponent]
})
export class HighlightCardComponent {
    @Output() raiseEvent: EventEmitter<Event> = new EventEmitter<Event>();
}
